export interface NotificationItem {
	type: NOTIFICATION_ITEM_TYPE;
	id: string;
	eventDate: number;
	eventType?: string;
	index: number;
}

export enum NOTIFICATION_ITEM_TYPE {
	NOTIFICATION = 'notification',
	ANNOUNCEMENT = 'announcement'
}
